import { i18n, utils } from "@common";
import { useState, useEffect } from 'react';
import { redirectTransferTo } from './utils/utils';
import { TabType } from './component/constant';
import LoginStudentID from './component/login/loginStudentID';
import LoginSingPass from './component/login/loginSingPass';
import './home.less';

const Home = props => {
    const [tabType, setTabType] = useState(TabType.Singpass);
    const transferData = JSON.parse(sessionStorage['transferData'] || null);
    const singpass = transferData?.detail?.SingPass;
    const azureADLogicalName = transferData?.detail?.AzureAD?.logicalName;
    const params = utils.geturlparam(window?.location.search);
    const { obj } = params;
    useEffect(() => {
        if (!obj?.proxyState) {
            utils.redirectTo('/student');
        }
        if (obj?.idp_hint) {
            redirectTransferTo(azureADLogicalName);
        }
    }, [azureADLogicalName, obj?.idp_hint, obj?.proxyState]);


    useEffect(() => {
        if (props.match.params?.active === "loginStudentID") {
            setTabType(Number(TabType.StudentId));
        }
    }, [props.match.params?.active]);

    const handleChangeTab = (res) => {
        setTabType(res);
    };

    return (
        singpass ?
            <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '6vh' }} className="mobile-wrap-top">
                    <R.Tabcontrol flex destroy active={tabType} onChange={handleChangeTab}  >
                        <R.TabPanel
                            tab={i18n.get('CIS_Home_Singpass_Tab_Entry')}
                            style={{ fontSize: '24px' }}
                            name="singpass"
                            key={0}
                        >
                            <LoginSingPass />
                        </R.TabPanel>
                        <R.TabPanel
                            tab={i18n.get('CIS_Home_StudentId_Tab_Entry')}
                            style={{ fontSize: '24px' }}
                            name="studentId"
                            key={1}
                        >
                            <LoginStudentID />
                        </R.TabPanel>
                    </R.Tabcontrol>
                </div>
            </div> :
            <LoginStudentID onlyStudentId={true} />
    );
};

export default Home;